import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Employee } from '@app/models/employee/employee.model';
import { TimesheetEntry } from '@app/models/time-tracking/timesheet-entry.model';
import { TimesheetEntryService, TimesheetOverlapErrorHandlingService } from '@app/modules/time-tracking/services';
import { NotifyService } from '@app/services';
import moment from 'moment';

/**
 * EmployeeTimesheetStore is used to enter timesheets from the
 * employee's profile
 */
@Component({
    templateUrl: './employee-timesheet-store.template.html',
})
export class EmployeeTimesheetStore implements OnInit {
    employee: Employee;
    timesheetEntries: TimesheetEntry[] = [];

    isLoading = true;
    hasLoadedData = false;
    overlapErrors: string[] = [];

    constructor(
        private location: Location,
        private route: ActivatedRoute,
        private notifyService: NotifyService,
        private timesheetEntryBatchService: TimesheetEntryService,
        private timesheetOverlapErrorHandlingService: TimesheetOverlapErrorHandlingService
    ) {
        this.employee = this.route.snapshot.data.models.get('employee');
    }

    async ngOnInit(): Promise<void> {
        this.loadData();
    }

    async onSave(): Promise<void> {
        try {
            this.isLoading = true;
            await this.timesheetEntryBatchService.createBatch(this.timesheetEntries);
            this.notifyService.success('time-tracking.enterHoursPage.success');
            this.location.back();
        } catch (error) {
            const { overlapErrors } = this.timesheetOverlapErrorHandlingService.handleHttpError(
                error as HttpErrorResponse
            );

            this.overlapErrors = overlapErrors;

            this.isLoading = false;
            throw error;
        }
    }

    private async loadData(): Promise<void> {
        const timesheetEntry = new TimesheetEntry({
            employeeId: this.employee.id,
        });

        timesheetEntry.employee = this.employee;
        timesheetEntry.workedOn = moment().format('YYYY-MM-DD');
        this.timesheetEntries = [timesheetEntry];
        this.hasLoadedData = true;
        this.isLoading = false;
    }
}
